import React from 'react';

import './button.css';

export const Button = ({
    onClick = (e) => {},
    rippleColor = 'rgba(0, 0, 0, 0.1)',
    rippleFade = true,
    multipleRipples = true,
    interactive = true,
    className = '',
    children,
    ...props
}) => {

    const ripple = (e) => {

        if (!interactive)
            return onClick(e);

        const btn = e.currentTarget;

        //Remove other ripples if multiple ripples is disabled
        // if (!multipleRipples)
        //     btn.querySelector('span')?.foreach(e => e.remove());

        const box = btn.getBoundingClientRect();
        const ripple = document.createElement('span');
        ripple.classList.add('ripple');
        ripple.style.left = e.clientX - box.left + 'px';
        ripple.style.top = e.clientY - box.top + 'px';
        ripple.style.backgroundColor = rippleColor;
        ripple.style.setProperty(
            '--animation-name',
            rippleFade ? 'rippleFade' : 'rippleNoFade'
        );

        window.requestAnimationFrame(() => {
            btn.append(ripple);
        });

        window.setTimeout(() => {
            if (ripple.parentNode)
                ripple.parentNode.removeChild(ripple);
        }, 500);

        return onClick(e);
    }

    return <button {...props} className={'button ' + (interactive ? 'interactive ' : '') + (className ?? '')} onClick={ripple}>
        <div className='button-contents'>
            {children}
        </div>
    </button>
}